/**
 * Enable GeoLocation
 */
export default async function electionlineGeolocation() { // Mark the main function as async to use await
  // console.log('I am loading - geolocation.js - Start');

  const stateName = getCookie('stateName');
  const stateCode = getCookie('stateCode');

  if (stateName && stateCode) {
      const state = {
          name: stateName,
          code: stateCode
      };
      updateUIWithStateInfo(state);

      // console.log('Getting information from cookie - ' + stateName + ', ' + stateCode);
  } else {
      console.log("No state information found in cookies.");
  }

  const cancelButton = document.querySelector('.geolocation-cancel');
  if (cancelButton) {
      cancelButton.addEventListener('click', function() {
          // Delete cookies
          deleteCookie('stateName');
          deleteCookie('stateCode');

          // Show all divs
          showAllDivs();

          // console.log('Cookies cleared and all divs displayed.');
      });
  }

  const locationTriggers = document.getElementsByClassName("geolocation-trigger");
  const triggerArray = Array.from(locationTriggers).entries();
  let $currentPath = document.location.pathname;
  let $approvedUris = ['/states'];
  let mobileMoreButton = document.getElementById('location__banner--mobile-more');

  for (let [index, trigger] of triggerArray) {
    trigger.addEventListener("click", async function() { // Use an async function for the event listener
      if ($currentPath.indexOf($approvedUris) > -1) {
        // console.log('Triggering GeoLocation');
        geoLocationLoaderContent();

        navigator.geolocation.getCurrentPosition(async (position) => { // Use async here
          // console.log('Geolocation successful!', position);

          const user_latitude = position.coords.latitude;
          const user_longitude = position.coords.longitude;

          try {
            const response = await getStateFromCoordinates(user_latitude, user_longitude); // Await the async call
            // console.log('Response received:', response);

            if (response.name) {
              updateUIWithStateInfo(response);
            } else {
              displayError('Location not within a US state');
            }
          } catch (error) {
            console.error('Failed to get state from coordinates:', error);
            displayError('Failed to process geolocation data');
          }
        }, (error) => {
          console.error('Geolocation failed:', error);
          displayError('Geolocation request failed');
        });
      }
    });
  }

  function updateUIWithStateInfo(state) {
    const geoLocationElement = document.getElementById('geolocation-found');
    geoLocationElement.innerHTML = state.name; // Display the state name

    // Hide the 'location' and 'Jump To' banners, as they are not needed.
    const defaultLocationBanner = document.getElementsByClassName("location__banner--default");
    defaultLocationBanner[0].style.display = "none";
    const jumpToBanner = document.querySelector(".location__jump-to-container");
    jumpToBanner.style.display = "none";

    // Show the 'located' banner.
    const locatedBanner = document.getElementsByClassName("location__banner--located");
    locatedBanner[0].style.display = "flex";



    // TODO: Save location to LocalStorage / Cookie.

    // Close Modal altogether, once we have the data AND it has been populated.
    let modalTrigger = document.getElementsByClassName("modal-item open-modal");
    let triggerArray = Array.from(modalTrigger).entries();
    for (let [index, modalTriggerItem] of triggerArray) {
      modalTriggerItem.classList.toggle("open-modal");
      // console.log(modalTrigger);
    }

    updateStateVisibility(state.code);

    // Save cookie
    saveStateToCookie(state.name, state.code);

  }

  function displayError(message) {
    const locationFailedWrapper  = document.getElementById('geolocation-failed');
    const locationFailed         = document.querySelector('div.geolocation-failed__warning h3');
    const locationPending        = document.getElementById('geolocation-pending');

    locationFailed.textContent           = message; // Update error message
    locationFailedWrapper.style.display  = "block";
    locationPending.style.display        = "none";
  }

  function geoLocationLoaderContent() {
    const locationPending = document.getElementById('geolocation-pending');
    locationPending.style.display = "flex";

    const modalTrigger = document.getElementById('modal-geotrigger');
    modalTrigger.style.display = "none";
  }

  function getStateFromCoordinates(latitude, longitude) {
    const accessToken = 'pk.eyJ1IjoibWFyaWFub2xhYiIsImEiOiJjbHYxMGZsOTgwMXZpMnJzMXZnYnJ4aWhhIn0.5xMzHrTnOuGAZhVWW_QMFQ';
    const url = `https://api.mapbox.com/geocoding/v5/mapbox.places/${longitude},${latitude}.json?types=region&access_token=${accessToken}`;
    
    return fetch(url) // Return the fetch promise
      .then(response => response.json())
      .then(data => {
        if (data.features && data.features.length) {
          const place = data.features.find(feature => feature.context.some(context => context.short_code === "us"));
          if (place) {
            return {
              name: place.text,
              code: place.properties.short_code.toUpperCase().split('-')[1]
            };
          }
          throw new Error('Location not within a US state');
        }
        throw new Error('No results found');
      });
  }

  function updateStateVisibility(stateCode) {
      // Hide all divs with classes 'state-accordion' y 'state-divider'
      const allDivs = document.querySelectorAll('.state-accordion, .state-divider');
      allDivs.forEach(div => {
          div.style.display = 'none'; // Ocultar div
      });

      // Show only those divs whose attribute 'data-state' matches 'stateCode'
      const matchingDivs = document.querySelectorAll(`.state-divider[data-state="${stateCode}"], .state-accordion[data-state="${stateCode}"]`);
      matchingDivs.forEach(div => {
          div.style.display = 'block'; 
      });
  }

  function showAllDivs() {
    const divs = document.querySelectorAll('.state-accordion, .state-divider');
    divs.forEach(div => {
        div.style.display = 'block'; // Show all divs
    });
}

  function setCookie(name, value, daysToExpire) {
    const date = new Date();
    date.setTime(date.getTime() + (daysToExpire * 24 * 60 * 60 * 1000)); // Configurar la fecha de expiración
    const expires = "expires=" + date.toUTCString();
    document.cookie = name + "=" + encodeURIComponent(value) + ";" + expires + ";path=/";
  }

  function getCookie(name) {
    const nameEQ = name + "=";
    const ca = document.cookie.split(';');
    for(let i=0; i < ca.length; i++) {
        let c = ca[i];
        while (c.charAt(0) === ' ') c = c.substring(1);
        if (c.indexOf(nameEQ) === 0) return decodeURIComponent(c.substring(nameEQ.length, c.length));
    }
    return null;
}

  function saveStateToCookie(stateName, stateCode) {
      setCookie('stateName', stateName, 7); 
      setCookie('stateCode', stateCode, 7); 
  }

  function deleteCookie(name) {
    document.cookie = name + '=; expires=Thu, 01 Jan 1970 00:00:01 GMT; path=/';
  }

  if (null !== mobileMoreButton) {
    mobileMoreButton.addEventListener('click', function() {
      if ( document.getElementById('location__banner--located').classList.contains('mobile-show') ) {
        document.getElementById('location__banner--located').classList.remove('mobile-show');
      } else {
        document.getElementById('location__banner--located').classList.add('mobile-show');
      }
    });
  }
}
